import styled from "@emotion/styled";
import { RequiredThemeKeys } from "@smartsheet/sds-theme-internal";
import { FocusMode } from "../../focusMode";

interface StyledContentAfterContainerProps {
    focusMode: FocusMode;
    isFocused: boolean;
    themeMode: RequiredThemeKeys;
    validationState: "error" | undefined;
}

export const StyledContentAfterContainer = styled("div")<StyledContentAfterContainerProps>`
    margin: ${getMargin};
    box-sizing: content-box;
`;

function getMargin({ validationState, isFocused, focusMode, themeMode }: StyledContentAfterContainerProps) {
    if (themeMode.includes("ursa") && (validationState === "error" || (isFocused && focusMode !== "keyboard"))) {
        return `var(--sds--textarea--content-after--margin-top, 6px) var(--sds--textarea--content-after--margin-right, 3px) var(--sds--textarea--content-after--margin-bottom, 3px) var(--sds--textarea--content-after--margin-left, 3px)`;
    } else {
        return `var(--sds--textarea--content-after--margin-top, 7px) var(--sds--textarea--content-after--margin-right, 4px) var(--sds--textarea--content-after--margin-bottom, 3px) var(--sds--textarea--content-after--margin-left, 3px)`;
    }
}
